import {withMeta, withSystem} from '@packages/systems/wfdl';

import {TEnum} from '@packages/systems/wfdl-ast';

export const loading = withMeta(
  {variant: 'menu'},
  withSystem(
    {label: 'Load', defaultValue: 'eager', isLocalizable: true},
    TEnum({
      lazy: 'Lazy: loads on scroll',
      eager: 'Eager: loads with page',
    })
  )
);
